import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextLarge, BodyTextMedium } from 'Packages/FacetDesign/Components/Text';
import {
  ClientRiskToleranceList,
} from 'Components/ComponentLibrary/Organisms/ClientRiskToleranceList/ClientRiskToleranceList';
import { HelpTextSection } from 'Components/ComponentLibrary/Organisms/HelpTextSection/HelpTextSection';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';

export default buildFacetDesignOverride()
  .nameOverride('primaryText', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('secondaryText', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly)
  .nameOverride('tertiaryText', {
    _component: () => BodyTextLarge,
  }, overrideReadOnly)
  .nameOverride('clients', {
    _component: () => ClientRiskToleranceList,
  }, overrideReadOnly)
  .nameOverride('resultHelpText', {
    _component: () => HelpTextSection,
  }, overrideReadOnly);
